import { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import classes from "./OBTRequirementModalContent.module.css";
import { useDispatch, useSelector } from "react-redux";
import { obtInfoManagementActions } from "Store/obtInfoManagement";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import FormControlLabel from "@mui/material/FormControlLabel";

const OBTRequirementsModalContent = (props) => {
  const details = useSelector((state) => state.obtInfoManagement);
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);

  const formControlLabelStyle = {
    "& .MuiFormControlLabel-label": {
      marginLeft: "10px",
      color: "#3f5765",
      fontFamily: "Urbanist",
      fontSize: "16px",
      fontWeight: "bold",
    },
  };

  useEffect(() => {
    setLoader(props.loading);
  }, [props.loading]);

  return (
    <>
      {loader ? (
        <div className={classes.loader}>
          <CircularProgress sx={{ color: "#A8A8A8" }} />
        </div>
      ) : null}
      <p className={classes.header}>
        OBT Requirements
        <CloseIcon
          sx={{
            fontSize: "23px",
            marginLeft: "24rem",
            cursor: "pointer",
          }}
          onClick={props.onClose}
        ></CloseIcon>
      </p>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.contactNumber}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setContactNumber(e.target.checked)
                  );
                }}
              />
            }
            label="Contact Number"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.address}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setAddress(e.target.checked)
                  );
                }}
              />
            }
            label="Address"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.nickname}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setNickname(e.target.checked)
                  );
                }}
              />
            }
            label="Nickname"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.state}
                onChange={(e) => {
                  dispatch(obtInfoManagementActions.setState(e.target.checked));
                }}
              />
            }
            label="State/Province"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.gender}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setGender(e.target.checked)
                  );
                }}
              />
            }
            label="Gender"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.postalCode}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setPostalCode(e.target.checked)
                  );
                }}
              />
            }
            label="Postal Code"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.nationalIdentifier}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setNationalIdentifier(
                      e.target.checked
                    )
                  );
                }}
              />
            }
            label="SSD/National ID"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.city}
                onChange={(e) => {
                  dispatch(obtInfoManagementActions.setCity(e.target.checked));
                }}
              />
            }
            label="City"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.licenseNPN}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setLicenseNPN(e.target.checked)
                  );
                }}
              />
            }
            label="License/NPN"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.country}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setCountry(e.target.checked)
                  );
                }}
              />
            }
            label="Country"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.dateOfBirth}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setDateOfBirth(e.target.checked)
                  );
                }}
              />
            }
            label="Date of Birth"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>

        <Grid item xs={6} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 27,
                    marginLeft: "10px",
                  },
                }}
                checked={details.email}
                onChange={(e) => {
                  dispatch(obtInfoManagementActions.setEmail(e.target.checked));
                }}
              />
            }
            label="Email"
            sx={{ ...formControlLabelStyle }}
          />
        </Grid>
      </Grid>
      <div className={classes.buttonContainer}>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            borderColor: "#1a8cff",
          }}
          variant="outlined"
          onClick={props.onClose}
        >
          Cancel
        </Button>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            backgroundColor: "#3299FF",
          }}
          variant="contained"
          onClick={props.handleSave}
          disabled={!props.isEdit}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default OBTRequirementsModalContent;
